import {
  Wrapper,
  Container,
  Video,
  CloseButton,
  Overlay,
  KinescopeIframe,
} from "./styledComponents";
import { useCallback } from "react";
import { closeModal } from "../../redux";
import { useDispatch } from "react-redux";

type Props = {
  video: string;
};

const VideoBoxModal = ({ video }: Props) => {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(closeModal("VideoBoxModal"));
  }, [dispatch]);
  
  const isKinescopeVideo = (url: string) => {
    return url.includes('kinescope.io');
  };
  const getKinescopeEmbedUrl = (url: string) => {
    if (url.includes('/embed/')) {
      return url;
    }
    const videoId = url.split('/').pop();
    return `https://kinescope.io/embed/${videoId}`;
  };

  return (
    <>
      <Overlay onClick={handleClose} />
      <Wrapper>
        <Container>
          <CloseButton
            icon="CloseIcon"
            size="l"
            color="white"
            onClick={handleClose}
          />
          {isKinescopeVideo(video) ? (
            <KinescopeIframe
              src={getKinescopeEmbedUrl(video)}
              allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write;"
              frameBorder="0"
              allowFullScreen
            />
          ) : (
            <Video controls src={video} datatype="video/mp4" autoPlay />
          )}
        </Container>
      </Wrapper>
    </>
  );
};

export default VideoBoxModal;
